import { Loader2 } from "lucide-react";

import { DynamicForm } from "./components/DynamicForm";
import { GenerateButton } from "./components/GenerateButton";
import { TaskTypeSelector } from "./components/TaskTypeSelector";
import { useCreateForm } from "./hooks/useCreateForm";

export const Create = () => {
  const form = useCreateForm();
  const { isLoading, isError, fromRunId } = form.meta;

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Loader2 className="size-6 animate-spin text-primary" />
      </div>
    );
  }

  if (isError && !form.taskTypes.length) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-2 px-4 text-center">
        <p className="font-medium text-foreground">Something went wrong</p>
        <p className="text-muted-foreground text-sm">
          We couldn't load content types. Please refresh and try again.
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl px-4 py-6 sm:px-6 sm:py-10">
      <div className="mb-6 sm:mb-8">
        <h1 className="font-bold text-2xl text-foreground sm:text-3xl">
          {fromRunId ? "Regenerate" : "Create"}
        </h1>
        <p className="mt-1.5 text-muted-foreground text-sm sm:mt-2 sm:text-base">
          {fromRunId
            ? "Adjust settings and generate a new version"
            : "Set up your AI twin and generate content"}
        </p>
      </div>

      <div className="space-y-5 sm:space-y-8">
        <TaskTypeSelector
          taskTypes={form.taskTypes}
          selectedId={form.selectedTaskType?.id ?? null}
          onSelect={form.selectTaskType}
        />

        {form.selectedTaskType && (
          <DynamicForm
            key={form.selectedTaskType.id}
            taskType={form.selectedTaskType}
            values={form.values}
            setValues={form.setValues}
          />
        )}

        <GenerateButton submit={form.submit} />
      </div>
    </div>
  );
};
